import { useParams } from 'react-router-dom';
import { SiTrackPage } from '../../../components/si-track-page';
import { SaveOfficeComponent } from './save-office.component';

export const CreateOfficePage = () => {
  const { id } = useParams();

  return (
    <SiTrackPage title="Edit Office">
      <SaveOfficeComponent customerID={Number(id)} page="create" />
    </SiTrackPage>
  );
};
